"use client"

import { Input } from "@/components/ui/input"
import { Combobox } from "@/components/ui/combobox"
import { useCodeValues } from "@/hooks/use-code-values"
import { useTranslation } from "@/hooks/use-translation"
import type { CodeItem } from "@/types/code-values"
import { CodeTableValueType } from "@/types/fbo-api"

interface DestinationValueInputProps {
  value: string
  onValueChange: (value: string) => void
  codeTableName?: string | null
  codeTableValueType?: number | null
  placeholder?: string
  id?: string
}

export function DestinationValueInput({
  value,
  onValueChange,
  codeTableName,
  codeTableValueType = CodeTableValueType.Id,
  placeholder = "e.g., 1",
  id
}: DestinationValueInputProps) {
  const { isReady, getCodeValues } = useCodeValues()
  const { t } = useTranslation()

  // Get code values if this is a code table field
  const codeValues: CodeItem[] = codeTableName && isReady
    ? getCodeValues(codeTableName, true) 
    : []

  if (codeTableName) {
    return (
      <Combobox
        value={value}
        onValueChange={onValueChange}
        options={[
          { value: "", label: t("common.state.none") },
          ...codeValues
            .sort((a, b) => a.text.localeCompare(b.text))
            .map(cv => {
              const storedValue = codeTableValueType === CodeTableValueType.Code ? cv.code : cv.id.toString()
              return {
                value: storedValue,
                label: `${cv.text}: ${storedValue}`,
              }
            }),
        ]}
        placeholder={t("destinationValue.select")}
        emptyText={t("destinationValue.empty")}
      />
    )
  }

  return (
    <Input
      id={id}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onValueChange(e.target.value)}
    />
  )
} 